// src/axiosInstance.js
import axios from 'axios';
import { API_URL } from '../Config';

// Create an axios instance to handle API requests
const axiosInstance = axios.create({
    baseURL: API_URL, // Replace with your API's base URL
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add a request interceptor to include the JWT token in the headers
axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('accessToken'); // Assuming the token is stored in localStorage
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default axiosInstance;
